import type { TaskInstance } from './task-instance.interface';

export interface cv_ScheduleReason {
    C_ScheduleReason_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    ScheduleReason: string;
    SortOrder: number | null;
    TaskInstance: TaskInstance[];
    Version: number;
}
